export default __webpack_public_path__ + "static/media/questionmark_83826 1.c55cd247.svg";